@switch (name) {
  @case ('Clipboard') {
    <lib-clipboard-icon classes="fill-white w-[25px] h-[24px]" />
  }

  @case ('Petronas') {
    <lib-petronas-icon />
  }

  @case ('HistoricalMr') {
    <lib-historical-mr-icon classes="fill-white" />
  }

  @case ('UserManagement') {
    <lib-user-management-icon />
  }

  @case ('Settings') {
    <lib-settings-icon />
  }

  @default {}
}
